import { ContextData } from '@dynamika-shared/types/clinicalTrialContext';
import { VisitConfig } from '@dynamika-shared/types/visits';
import { makeFlatAllLabels } from '@restore/clinicalTrialContext/transformers';

export const getLabelsForVisit = (
  context: ContextData | undefined | null,
  visitId: string | undefined
) => {
  if (!context || !visitId) {
    return [];
  }
  const visitData: VisitConfig | undefined = context.configuration.cohorts
    .flatMap(({ visits }) => visits)
    .find(v => v.id === visitId);

  const flatLabelGroups = makeFlatAllLabels(context.configuration.labelGroups);

  return visitData?.labels.map(label => flatLabelGroups[label]);
};
